module.exports = __webpack_public_path__ + "img/setting-step-three.15ceba90.png";